(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

(function optimizeGurBakirCategoryTabs() {
  const warmers = new Set();

  function init(root) {
    if (!root || root.dataset.gbPerfReady === 'true') return;
    root.dataset.gbPerfReady = 'true';

    const tabs = [...root.querySelectorAll('[data-gb-tab]')];
    const panels = [...root.querySelectorAll('[data-gb-panel]')];
    const panelMap = new Map(panels.map((panel) => [panel.dataset.gbPanel, panel]));

    function getCardWidth() {
      const visiblePanel = panels.find((panel) => !panel.hidden) || panels[0];
      const card = visiblePanel?.querySelector('.gb-tabs__card');
      return card ? Math.ceil(card.getBoundingClientRect().width) : 0;
    }

    function updateImageSizes() {
      const width = getCardWidth();
      if (!width) return;
      root.querySelectorAll('img.gb-tabs__image').forEach((img) => {
        img.sizes = `${width}px`;
        img.decoding = 'async';
      });
    }

    function warmPanel(panel, priority = 'low') {
      if (!panel || panel.dataset.gbWarmed === 'true') return;
      panel.dataset.gbWarmed = 'true';
      updateImageSizes();

      panel.querySelectorAll('img.gb-tabs__image').forEach((img, index) => {
        if (img.complete && img.naturalWidth) return;
        const preloader = new Image();
        preloader.decoding = 'async';
        if ('fetchPriority' in preloader) {
          preloader.fetchPriority = priority === 'high' && index < 2 ? 'high' : 'low';
        }
        preloader.sizes = img.sizes;
        preloader.srcset = img.srcset;
        preloader.src = img.currentSrc || img.src;
        warmers.add(preloader);
        const release = () => warmers.delete(preloader);
        preloader.addEventListener('load', release, { once: true });
        preloader.addEventListener('error', release, { once: true });
      });
    }

    function prioritize(panel) {
      if (!panel) return;
      updateImageSizes();
      panel.querySelectorAll('img.gb-tabs__image').forEach((img, index) => {
        img.loading = 'eager';
        img.decoding = 'async';
        if ('fetchPriority' in img) img.fetchPriority = index < 2 ? 'high' : 'auto';
      });
    }

    updateImageSizes();

    tabs.forEach((tab) => {
      const targetPanel = () => panelMap.get(tab.dataset.gbTab);
      const warmTarget = () => warmPanel(targetPanel(), 'low');
      tab.addEventListener('pointerenter', warmTarget, { passive: true });
      tab.addEventListener('focus', warmTarget);
      tab.addEventListener('touchstart', warmTarget, { passive: true });
      tab.addEventListener('click', () => {
        const panel = targetPanel();
        warmPanel(panel, 'high');
        requestAnimationFrame(() => prioritize(panel));
      });
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateImageSizes).observe(root);
    } else {
      window.addEventListener('resize', updateImageSizes, { passive: true });
    }

    const warmHiddenPanels = () => {
      updateImageSizes();
      const hidden = panels.filter((panel) => panel.hidden);
      hidden.forEach((panel, index) => {
        window.setTimeout(() => warmPanel(panel, 'low'), index * 450);
      });
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        warmHiddenPanels();
        observer.disconnect();
      }, { rootMargin: '1000px 0px' });
      observer.observe(root);
    } else {
      window.setTimeout(warmHiddenPanels, 1200);
    }
  }

  document.querySelectorAll('.gb-tabs').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.('.gb-tabs');
    if (root) init(root);
  });
})();
